export enum WIDGET_TYPES {
  GENERAL = 'general',
  CONNECT_DATA = 'connect-data',
  SYNC_TABLES = 'sync-tables',
}
